/**
 * Content carousel with extensive options to control behaviour and appearance
 * @requires https://github.com/ganlanyuan/tiny-slider
 */

const carousel = () => {

    if ('undefined' === typeof tns) {
        console.info('tiny-slider is not loaded!');
        return;
    }

    const classBound = 'has-bound-carousel';
    const selector = `.tns-carousel .tns-carousel-inner:not(${classBound})`;
    let carousels = document.querySelectorAll(selector);

    //for (let element of carousels) {
    for (let i = 0; i < carousels.length; i++) {
        let element = carousels[i];

        if (element.classList.contains(classBound)) {
            continue;
        }

        // Carousel initialisation
        let defaults = {
            container: element,
            controlsText: ['<i class="ci-arrow-left"></i>', '<i class="ci-arrow-right"></i>'],
            navPosition: 'bottom',
            mouseDrag: true,
            speed: 500,
            autoplayHoverPause: true,
            autoplayButtonOutput: false
        };
        let userOptions = {};
        if (element.dataset.carouselOptions != undefined) {
            userOptions = JSON.parse(element.dataset.carouselOptions);
        }
        let options = Object.assign({}, defaults, userOptions);
        let carousel = tns(options);

        element.classList.add(classBound);
    }
};

export default carousel;

carousel();
